import { getUIDescription } from "../components/SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";
import axios from "../utils/axiosInstance";
import { getWellsFromAPI } from "./wellsConfig";

export const WELLPRO_REGISTERS = [
  "_40307",
  "_40271",
  "_40272",
  "_40289",
  "_40306",
  "_40339",
  "_40340",
  "_40322",
  "_40298",
  "_40337",
  "_40338",
  "_40108",
  "_40280",
  "_40281"
];

export const C5_REGISTERS = [
  "_40008",
  "_40505",
  "_40624",
  "_41001",
  "_41002",
  "_41023",
  "_41031",
  "_41035",
  "_41040",
  "_41041",
  "_41042",
  "_41047",
  "_41048",
  "_41049",
  "_41492",
  "_41493",
  "_41517",
  "_41541",
  "_41542",
  "_41553",
  "_41579",
  "_41580",
  "_41649",
  "_41652",
  "_41653",
  "_41654",
  "_41702",
  "_41714",
  "_41715",
  "_41716",
  "_41717",
  "_42403",
  "_43792",
  "_43793",
  "_43979",
  "_43984",
  "_43985",
  "_44039",
  "_44115",
  "_44119",
  "_44131",
  "_44135",
  "_40505",
  "_41560",
  "_41561",
];

// For update setpoints button

export const getSPcmd = async (
  unitId,
  registerList,
  cmd,
  baseline,
  setProgressSuccess,
  setProgressError,
  setProgressOpen
) => {
  let pollInterval = null;

  const stopPolling = () => {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
  };

  const pollForChange = ({
    initialTime,
    initialResponse,
    durationMs,
    intervalMs,
    onSuccess,
    onTimeout,
  }) => {
    const start = Date.now();

    pollInterval = setInterval(async () => {
      try {
        const resp = await axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
          registerList
        );

        const { time: currentTime, response: currentResponse } =
          resp.data.data || {};

        const timeChanged =
          currentTime && Number(currentTime) !== Number(initialTime);
        console.log("outside currentResponse", currentResponse)
        console.log("outside initialResponse", initialResponse)
        let valueChanged = false;
        for (const key in currentResponse) {
          if (currentResponse[key] !== initialResponse[key]) {
            console.log("inside currentResponse[key]", currentResponse[key])
            console.log("inside initialResponse[key]", initialResponse[key])
            valueChanged = true;
            break;
          }
        }
        console.log("⏳ Polling...", {
          currentTime,
          timeChanged,
          valueChanged,
        });

        if (timeChanged && valueChanged) {
          stopPolling();
          onSuccess({
            currentTime,
            currentResponse,
          });
          console.log("🔄 Device time changed:", initialTime, "->", currentTime, "and data changed", initialResponse, "->", currentResponse);
        }

        if (Date.now() - start >= durationMs) {
          stopPolling();
          onTimeout();
        }
      } catch (err) {
        console.warn("Polling error:", err.message);
      }
    }, intervalMs);
  };
  try {
    // Step 1: get initial timestamp from baseline API
    let initialTime = baseline.time;
    let initialResponse = baseline.response;
    console.log("Initial time:", initialTime);
    console.log("Initial regList:", initialResponse);

    // 2️⃣ Poll 30s after S
    pollForChange({
      initialTime,
      initialResponse,
      durationMs: 30000,
      intervalMs: 4000,

      onSuccess: () => {
        console.log("✅ Updated after S");
        setProgressSuccess(true);
      },

      onTimeout: async () => {
        console.log("⏰ No change after S → sending P");

        // 3️⃣ Send P
        await axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
          { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`, },
          { headers: { id: "anything", "Content-Type": "application/json" } }
        );
        console.log("🟢 P command sent, polling again...");
        // === STEP 5: poll AFTER P ===
        pollForChange({
          unitId,
          registerList,
          initialTime,
          initialResponse,
          durationMs: 170000,
          intervalMs: 4000,

          onSuccess: () => {
            console.log("✅ Update done after P command");
            setProgressSuccess(true);
          },

          onTimeout: () => {
            console.warn("❌ Timeout after P command");
            setProgressError(
              "⏰ Timeout waiting for device response. Please try again."
            );
          },
        });
      },
    });
  } catch (err) {
    console.error("plgSendCommand failed:", err);
    setProgressOpen(false);
  }
};

export const requestSetpoints = async (
  unitId,
  P_CMD,
  baseline,
  setProgressSuccess,
  setProgressError,
  setProgressOpen
) => {
  console.log("P command:", P_CMD)
  try {
    const wellType = await getWellsFromAPI(unitId);

    // Step 1: Open dialog
    setProgressOpen(true);
    setProgressSuccess(false);

    // Step 2: Wait a short delay to allow UI to render
    setTimeout(async () => {
      if (wellType?.type === "WellPro II" || wellType?.type === "WP") {
        await getSPcmd(
          unitId,
          WELLPRO_REGISTERS,
          P_CMD,
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      } else {
        await getSPcmd(
          unitId,
          C5_REGISTERS,
          P_CMD,
          baseline,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      }
    }, 100);
  } catch (err) {
    console.error("❌ getSetpoints failed:", err);
    setProgressError("Failed to retrieve setpoints.");
    setProgressOpen(false);
  }
};

// For get setpoints button

export const handleGetSetpoints = async (
  unitId,
  registerList,
  cmd,
  setProgressSuccess,
  setProgressError,
  setProgressOpen
) => {
  let pollInterval = null;

  const stopPolling = () => {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
  };

  const pollForChange = ({
    lastTime,
    durationMs,
    intervalMs,
    onSuccess,
    onTimeout,
  }) => {
    const start = Date.now();

    pollInterval = setInterval(async () => {
      try {
        const resp = await axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
          registerList
        );

        const { time: currentTime } = resp.data.data || {};

        const timeChanged =
          currentTime && Number(currentTime) !== Number(lastTime);

        console.log("⏳ Polling...", { lastTime, currentTime });

        if (timeChanged) {
          stopPolling();
          onSuccess({
            currentTime,
          });
          console.log("🔄 Device time changed:", lastTime, "->", currentTime);
        }

        if (Date.now() - start >= durationMs) {
          stopPolling();
          onTimeout();
        }
      } catch (err) {
        console.warn("Polling error:", err.message);
      }
    }, intervalMs);
  };
  try {
    const initialResp = await axios.post(
      `${process.env.REACT_APP_API_GATEAWAY}/iot/device_get_by_register/${unitId}`,
      registerList
    );
    let lastTime = Number(initialResp.data.data?.time || 0);
    console.log("Initial time:", lastTime);
    // 2️⃣ Poll 30s after S

    // 3️⃣ Send P
    await axios.post(
      `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
      { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`, },
      { headers: { id: "anything", "Content-Type": "application/json" } }
    );
    console.log("🟢 P command sent, polling...");
    // === STEP 5: poll AFTER P ===
    pollForChange({
      unitId,
      registerList,
      lastTime,
      durationMs: 170000,
      intervalMs: 4000,

      onSuccess: () => {
        console.log("✅ Update done after P command");
        setProgressSuccess(true);
      },

      onTimeout: () => {
        console.warn("❌ Timeout after P command");
        setProgressError(
          "⏰ Timeout waiting for device response. Please try again."
        );
      },
    });
  } catch (err) {
    console.error("❌ getSetpoints failed:", err);
    setProgressError("Failed to retrieve setpoints.");
    setProgressOpen(false);
  }
};

export const getSetpoints = async (
  unitId,
  P_CMD,
  setProgressSuccess,
  setProgressError,
  setProgressOpen
) => {
  try {
    const confirmed = window.confirm(
      "Please confirm you want to pull Unit Setpoints"
    );
    if (!confirmed) return;
    console.log("P command:", P_CMD)
    const wellType = await getWellsFromAPI(unitId);

    // Step 1: Open dialog
    setProgressOpen(true);
    setProgressSuccess(false);

    // Step 2: Wait a short delay to allow UI to render
    setTimeout(async () => {
      if (wellType?.type === "WellPro II" || wellType?.type === "WP") {
        await handleGetSetpoints(
          unitId,
          WELLPRO_REGISTERS,
          P_CMD,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      } else {
        await handleGetSetpoints(
          unitId,
          C5_REGISTERS,
          P_CMD,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      }
    }, 100);
  } catch (err) {
    console.error("❌ getSetpoints failed:", err);
    setProgressError("Failed to retrieve setpoints.");
    setProgressOpen(false);
  }
};

// For clear fault & stop engine buttons

export const getClearFaultCmd = async (
  unitId,
  cmd,
  setProgressSuccess,
  setProgressError,
  setProgressOpen
) => {
  let pollInterval = null;

  const stopPolling = () => {
    if (pollInterval) {
      clearInterval(pollInterval);
      pollInterval = null;
    }
  };
  const pollForTimeChange = ({
    unitId,
    lastTime,
    durationMs,
    intervalMs,
    onSuccess,
    onTimeout,
  }) => {
    const start = Date.now();

    pollInterval = setInterval(async () => {
      try {
        const resp = await axios.get(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/plungers/${unitId}`
        );

        const currentTime = Number(resp.data.data?.time || 0);

        console.log("⏳ Polling...", { lastTime, currentTime });

        if (currentTime && currentTime !== lastTime) {
          stopPolling();
          console.log("🔄 Device time changed:", lastTime, "->", currentTime);
          onSuccess(currentTime);
        }

        if (Date.now() - start >= durationMs) {
          stopPolling();
          onTimeout();
        }
      } catch (err) {
        console.warn("Polling error:", err.message);
      }
    }, intervalMs);
  };
  try {
    // Step 1: get initial timestamp
    const initialResp = await axios.get(
      `${process.env.REACT_APP_API_GATEAWAY}/iot/plungers/${unitId}`
    );
    let lastTime = Number(initialResp.data.data?.time || 0);
    console.log("Initial time:", lastTime);

    // === Step 3: poll DURING 30s ===
    pollForTimeChange({
      unitId,
      lastTime,
      durationMs: 30000,
      intervalMs: 4000,

      onSuccess: () => {
        console.log("✅ Fault cleared after A command");
        setProgressSuccess(true);
      },

      onTimeout: async () => {
        console.log("⏰ No change after A, sending P command...");

        // 3️⃣ Send P
        await axios.post(
          `${process.env.REACT_APP_API_GATEAWAY}/iot/control/precision/cmd`,
          { unitId, cmd,UI_Description: `${getUIDescription()}\n Send Command to the controller \nCmd: ${cmd}`, },
          { headers: { id: "anything", "Content-Type": "application/json" } }
        );

        console.log("🟢 P command sent, polling again...");

        // === Step 5: poll AFTER P ===
        pollForTimeChange({
          unitId,
          lastTime,
          durationMs: 170000,
          intervalMs: 4000,

          onSuccess: () => {
            console.log("✅ Fault cleared after P command");
            setProgressSuccess(true);
          },

          onTimeout: () => {
            console.warn("❌ Timeout after P command");
            setProgressError(
              "⏰ Timeout waiting for device response. Please try again."
            );
          },
        });
      },
    });
  } catch (err) {
    console.error("plgSendCommand failed:", err);
    setProgressOpen(false);
  }
};

export const requestClearFault = async (
  unitId,
  P_CMD,
  setProgressSuccess,
  setProgressError,
  setProgressOpen
) => {
  try {
    const wellType = await getWellsFromAPI(unitId);

    // Step 1: Open dialog
    setProgressOpen(true);
    setProgressSuccess(false);

    // Step 2: Wait a short delay to allow UI to render
    setTimeout(async () => {
      if (wellType?.type === "WellPro II" || wellType?.type === "WP") {
        await getClearFaultCmd(
          unitId,
          P_CMD,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      } else {
        await getClearFaultCmd(
          unitId,
          P_CMD,
          setProgressSuccess,
          setProgressError,
          setProgressOpen
        );
      }
    }, 100);
  } catch (err) {
    console.error("❌ getSetpoints failed:", err);
    setProgressError("Failed to retrieve setpoints.");
    setProgressOpen(false);
  }
};
